<template>
    <div style="background-color: black">
        <b-card title="Review Images" class="m-4">

            <b-btn @click="$emit('back')">
                <i class="fas fa-chevron-left pr-1"></i>
                Back to login
            </b-btn>
            
            <b-tabs class="pt-3">
                <b-tab title="Incomplete" class="pt-4">

                    <b-row>
                        <b-col cols=4 lg=3 v-for="r in reviews.filter(r => !r.reviewed)" :key="r._id" class="mb-3">
                            <b-card     :img-src="r.screenshot" 
                                        class="text-right" 
                                        style="cursor: pointer"
                                        @click="review = JSON.parse(JSON.stringify(r)); $refs.reviewModal.show()"
                            >
                                {{ r.comments.length }} comment(s)

                                <div class="pt-1">
                                    <b-btn size=sm variant="danger" @click.stop="deleteReview(r)">Delete</b-btn>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>

                    <div v-if="reviews.filter(r => !r.reviewed).length == 0" class="text-center py-4">
                        <i>There are no images in this category.</i>
                    </div>
                </b-tab>

                <b-tab title="Complete" class="pt-4">

                    <b-row>
                        <b-col cols=4 lg=3 v-for="r in reviews.filter(r => r.reviewed)" :key="r._id" class="mb-3">
                            <b-card     :img-src="r.screenshot" 
                                        class="text-right" 
                                        style="cursor: pointer"
                                        @click="review = JSON.parse(JSON.stringify(r)); $refs.reviewModal.show()"
                            >
                                {{ r.comments.length }} comment(s)

                                <div class="pt-1">
                                    <b-btn size=sm variant="danger" @click.stop="deleteReview(r)">Delete</b-btn>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>

                    <div v-if="reviews.filter(r => r.reviewed).length == 0" class="text-center py-4">
                        <i>There are no images in this category.</i>
                    </div>
                </b-tab>

            </b-tabs>

        </b-card>

        <b-modal title="Review Screenshot" ref="reviewModal" @ok="updateReview">
            <div v-if="review">
                <b-img :src="review.screenshot" responsive thumbnail />

                <b-form-group v-for="(comment,index) in review.comments" :key="index"  :label="(comment.name || 'Reviewer') + ' commented:'" class="mt-2">
                    <b-textarea v-model="comment.text" :disabled="true" no-resize />
                </b-form-group>

                <b-form-group label="Add your comments">
                    <b-textarea rows=2 max-rows=3 no-resize v-model="comment" />

                    <!-- <div class="text-right pt-2"> -->
                        <!-- <b-btn variant="primary" @click="review.comments.push({ text: comment }); -->
                         <!-- comment = '',updateReview()">Add comment</b-btn> -->
                    <!-- </div> -->
                <b-row class="pt-3">
                <b-col lg="6" class="pb-2">
                    <b-button  variant="primary" 
                    @click="review.comments.push({ userId: user._id, name: `${user.firstName} ${user.lastName}`,
                    text: comment });comment = '', updateReview()"> Add comment
                    </b-button>
                    
                </b-col>
                <b-col lg="6" class="pb-2 text-right">
                    <b-button variant="primary" @click="comment = ''"> Delete comment
                    </b-button>
                </b-col>
                </b-row>
                </b-form-group>

                <b-form-group label="Review Completed?">
                    <b-radio-group v-model="review.reviewed">
                        <b-radio :value="false">Incomplete</b-radio>
                        <b-radio :value="true">Complete</b-radio>
                    </b-radio-group>
                </b-form-group>
            </div>

        </b-modal>
    </div>
</template>

<script>
import axios from 'axios';

const baseUrl = process.env.VUE_APP_SERVER;//'https://ed.smartlabsltd.com';

export default {
    data() {
        return {
            reviews: [],
            review: {},

            user: {},
            comment: ''
        }
    },

    async mounted() {
        this.loadReviews();
    },

    methods: {
        async loadReviews() {
            var response = await axios.get(baseUrl + '/review');
            this.reviews = response.data;
            this.reviews.forEach(r => {
                if (!r.reviewerComments) {
                    this.$set(r, 'reviewerComments', '');
                }

                if (!r.reviewed) {
                    this.$set(r, 'reviewed', false);
                }
            })
        },

        async updateReview() {
            // eslint-disable-next-line no-unused-vars
            var response = await axios.patch(baseUrl + '/review', this.review);
            this.loadReviews();
        },

        async deleteReview(review) {
            // eslint-disable-next-line no-console
            console.log(review);

            // eslint-disable-next-line no-unused-vars
            var response = await axios.delete(baseUrl + '/review/' + review._id);
            this.loadReviews();
        }
    }
}
</script>